import { render, staticRenderFns } from "./SettingConfirmDialog.vue?vue&type=template&id=b727e062&"
import script from "./SettingConfirmDialog.vue?vue&type=script&scoped=true&lang=js&"
export * from "./SettingConfirmDialog.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./SettingConfirmDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../NodeModules/Ljbc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports